import { render, staticRenderFns } from "./DataTableDSMS.vue?vue&type=template&id=365e1f21&scoped=true"
import script from "./DataTableDSMS.vue?vue&type=script&lang=js"
export * from "./DataTableDSMS.vue?vue&type=script&lang=js"
import style0 from "./DataTableDSMS.vue?vue&type=style&index=0&id=365e1f21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365e1f21",
  null
  
)

export default component.exports